<template>
  <div class="details-wrapper">
    <div class="details-header">Client Contact#{{ getClientContactRef }}</div>
    <div class="details-body">
      <tol-sidebar :menu-items="sidebarMenu" />
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <section class="details-section">
            <h1>{{ this.$t('clientContact.labels.details') }}</h1>
            <ClientContactDetailsForm :client-contact="getClientContact" />
          </section>
          <section class="details-section">
            <h1>{{ this.$t('clientContact.labels.assignments') }}</h1>
            <tol-table
              :table-data="getClientContactAssignments"
              :columns="assignmentColumns"
              class="assignment"
            >
              <template v-slot:tableHeader>
                <th>{{ $t('clientContact.labels.referenceNumber') }}</th>

                <th-sortable
                  :direction="
                    currentSortFieldForAssignments === 'payroll_number'
                      ? currentSortDirectionForAssignments
                      : 'none'
                  "
                  field-name="payroll_number"
                  @change="onAssignmentSortOrderChange"
                  >{{ $t('clientContact.labels.payrollNumber') }}</th-sortable
                >
                <th-sortable
                  :direction="
                    currentSortFieldForAssignments === 'contractor'
                      ? currentSortDirectionForAssignments
                      : 'none'
                  "
                  field-name="contractor"
                  @change="onAssignmentSortOrderChange"
                  >{{ $t('clientContact.labels.contractor') }}</th-sortable
                >

                <th-sortable
                  :direction="
                    currentSortFieldForAssignments === 'client'
                      ? currentSortDirectionForAssignments
                      : 'none'
                  "
                  field-name="client"
                  @change="onAssignmentSortOrderChange"
                  >{{ $t('clientContact.labels.client') }}</th-sortable
                >

                <th>{{ $t('clientContact.labels.approvers') }}</th>
                <th-sortable
                  :direction="
                    currentSortFieldForAssignments === 'startDate'
                      ? currentSortDirectionForAssignments
                      : 'none'
                  "
                  field-name="startDate"
                  @change="onAssignmentSortOrderChange"
                  >{{ $t('clientContact.labels.startDate') }}</th-sortable
                >
                <th-sortable
                  :direction="
                    currentSortFieldForAssignments === 'stopDate'
                      ? currentSortDirectionForAssignments
                      : 'none'
                  "
                  field-name="stopDate"
                  @change="onAssignmentSortOrderChange"
                  >{{ $t('clientContact.labels.stopDate') }}</th-sortable
                >
                <th-sortable
                  :direction="
                    currentSortFieldForAssignments === 'branch'
                      ? currentSortDirectionForAssignments
                      : 'none'
                  "
                  field-name="branch"
                  @change="onAssignmentSortOrderChange"
                  >{{ $t('clientContact.labels.branch') }}</th-sortable
                >
                <th-sortable
                  :direction="
                    currentSortFieldForAssignments === 'status'
                      ? currentSortDirectionForAssignments
                      : 'none'
                  "
                  field-name="status"
                  @change="onAssignmentSortOrderChange"
                  >{{ $t('clientContact.labels.status') }}</th-sortable
                >
              </template>
              <template v-slot:referenceNumber="{ value }">
                <router-link :to="'/assignments/' + value.referenceNumber">
                  {{ value.referenceNumber }}
                </router-link>
              </template>
            </tol-table>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AppActions } from '@/app/app.keys';
import { mapGetters } from 'vuex';
import TolSidebar from '@/app/components/TolSidebar';
import TolTable from '@/app/components/TolTable';
import ThSortable from '@/app/components/ThSortable';
import ClientContactDetailsForm from '@/app/features/client-contacts/features/client-contact-details/components/ClientContactDetailsForm';
import {
  ClientContactActions,
  ClientContactGetters
} from '@/app/features/client-contacts/features/client-contact-details/client-contact-details.keys';

export default {
  components: {
    TolSidebar,
    ClientContactDetailsForm,
    TolTable,
    ThSortable
  },
  data() {
    return {
      sidebarMenu: [
        { label: this.$t('clientContact.labels.details') },
        { label: this.$t('clientContact.labels.assignments') }
      ],
      assignmentColumns: [
        'referenceNumber',
        'payroll_number',
        'contractor',
        'client',
        'approvers',
        'startDate',
        'stopDate',
        'branch',
        'status'
      ]
    };
  },
  computed: {
    ...mapGetters([
      ClientContactGetters.GetClientContact,
      ClientContactGetters.GetClientContactAssignments
    ]),
    getClientContactRef() {
      return this.getClientContact.user.reference_number;
    },
    currentSortDirectionForAssignments() {
      return this.$store.getters[ClientContactGetters.ClientContactAssignmentsSortOrder]
        .sortDirection;
    },
    currentSortFieldForAssignments() {
      return this.$store.getters[ClientContactGetters.ClientContactAssignmentsSortOrder].sortBy;
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('clientContact.details.clientContact'));
    this.$store.dispatch(ClientContactActions.GetClientContactAssignments, this.$route.params.id);
    this.$store.dispatch(ClientContactActions.GetClientContact, this.$route.params.id);
  },
  methods: {
    onAssignmentSortOrderChange(sortOrder) {
      this.$store.dispatch(ClientContactActions.SetContractorAssignmentsSortOrder, sortOrder);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;
  .details-header {
    display: flex;

    padding: $details-padding;
    border-bottom: 2px solid $row-border;
    justify-content: space-between;
  }
  .details-body {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      flex: 0 85%;
      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px;
      }
    }

    .details-section {
      padding-bottom: 25px;

      h1 {
        border-bottom: 1px solid $row-border;
      }

      .address-section {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }
    }
  }
}
</style>
